<template>
    <vue-apex-charts
        type="pie"
        height="350"
        layout="compact"
         ref="donutChartTitulo"
        :options="apexChatData.donutChartTitulo.chartOptions"
        :series="apexChatData.donutChartTitulo.series"
    />
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import { mapGetters } from 'vuex';
import apexChatData from './apexChartData';

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      apexChatData,
    };
  },
  methods: {
    atualizarGfTitulo() {
      this.$nextTick(() => {
        this.$refs.donutChartTitulo.refresh();
        this.$refs.donutChartTitulo.updateOptions({
          labels: this.optionData.labels,
          series: this.optionData.series,
          total: this.qtdPedidos,
        });
      });
    },
  },
  computed: {
    ...mapGetters({
      qtdPedidos: 'PTC_Dashboard/gePedidosDash',
    }),
  },
};
</script>
